import * as sortabular from 'sortabular';
import { compose, isEmpty, orderBy } from '@elliemae/ds-utilities/utils';
import { appendHeaderFormatter, mergeClassNameToColumnHeader } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import sortHeaderFormatter from './sortHeaderFormatter.js';
import { useSortableState } from './useSortableState.js';
import { sorterGroups, sorter } from './sorter.js';
import 'react';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/ArrowheadDown';
import '@elliemae/ds-icons/ArrowheadUp';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'sortabular/dist';
import '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import './checkIfSortable.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'moment';

var decorateColumn = function decorateColumn(column, grid) {
  var _grid$props = grid.props,
      _grid$props$isSortabl = _grid$props.isSortableColumnActive,
      isSortableColumnActive = _grid$props$isSortabl === void 0 ? function (col) {
    return col.sortable;
  } : _grid$props$isSortabl,
      groupedRows = _grid$props.groupedRows;
  if (groupedRows) return column;
  if (!isSortableColumnActive(column)) return column;
  var formatter = sortHeaderFormatter(sortabular.sort({
    getSortingColumns: function getSortingColumns() {
      return grid.getState().sortingColumns || [];
    },
    onSort: grid.actions.sort,
    strategy: sortabular.strategies.byProperty
  }), grid);
  return compose(appendHeaderFormatter(formatter), mergeClassNameToColumnHeader('with-sortable'))(column);
};

var composeRows = function composeRows(rows, grid) {
  var _grid$getInstance = grid.getInstance(),
      sortingColumns = _grid$getInstance.state.sortingColumns,
      _grid$getInstance$pro = _grid$getInstance.props,
      isDataSorted = _grid$getInstance$pro.isDataSorted,
      groupedRows = _grid$getInstance$pro.groupedRows,
      groupedBy = _grid$getInstance$pro.groupedBy,
      sortEmptyLast = _grid$getInstance$pro.sortEmptyLast,
      rowsData = _grid$getInstance.rows,
      composedRows = _grid$getInstance.composedRows,
      decoratedColumns = _grid$getInstance.decoratedColumns;

  var sortingConfig = {
    columns: decoratedColumns,
    sortingColumns: !isEmpty(sortingColumns) && sortingColumns,
    sort: orderBy,
    emptyLast: sortEmptyLast
  }; // TODO: 1572 FIX

  if (groupedRows && !groupedBy) {
    return !isDataSorted ? sorterGroups(sortingConfig)(composedRows, rowsData, groupedBy) : rows;
  }

  return !isDataSorted ? sorter(sortingConfig)(rows) : rows;
};

var SortablePlugin = createInstancePlugin('sortable', {
  registerStateHook: useSortableState,
  decorateColumn: decorateColumn,
  composeRows: composeRows,
  registerHotKeys: function registerHotKeys(grid) {
    return {
      key: 'ctrl+s',
      handler: function handler(_ref) {
        var cellIndex = _ref.cellIndex;

        var _grid$getInstance2 = grid.getInstance(),
            sort = _grid$getInstance2.actions.sort,
            decoratedColumns = _grid$getInstance2.decoratedColumns;

        var column = decoratedColumns[cellIndex];
        if (!column) return;
        sort(column.property);
      }
    };
  }
});

export { SortablePlugin };
//# sourceMappingURL=SortablePlugin.js.map
